/* eslint-disable react/display-name */
import * as React from 'react';

const Website = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect width={16} height={16} style={{ fill: '#fff', fillOpacity: 0 }} />
    <g id="Mask">
      <path d="M3.31,13C1.48,13,0,11.28,0,9.11V.59A.54.54,0,0,1,.49,0h15A.54.54,0,0,1,16,.59V9.11C16,11.28,14.52,13,12.69,13H10.6l.22,1.06h.62a.54.54,0,0,1,.49.58v.74a.54.54,0,0,1-.49.59H4.56a.54.54,0,0,1-.49-.59v-.74a.54.54,0,0,1,.49-.58h.62L5.4,13Zm5.62,0H7.07l-.23,1.06H9.16ZM2,1.91v7.2a1.88,1.88,0,0,0,1.7,2h8.5a1.88,1.88,0,0,0,1.7-2V1.91Z" />
    </g>
  </svg>
);

export default Website;
